import React, { useEffect, Fragment, useState } from 'react';
import {
    Facebook,
    Instagram,
    Linkedin,
    Twitter,
    Mail
} from 'react-feather';
import Breadcrumb from '../common/breadcrumb';
import search from '../../assets/images/search-not-found.png';
import userDemoPic from '../../assets/images/user/user.png';
import firebase from '../../data/base';
import { markPriority, deletedUser } from '../../services/member.service';


const AvatarImage = ({
    avatar
}) => {
    const [avatarImg, setAvatarImg] = useState(userDemoPic);
    // fetch for images when blog is ready
    useEffect(() => {
        const fetchImg = async avatar => {
            const imgRef = firebase
                .storage()
                .ref(avatar.fullPath || '');

            const imgURL = await imgRef.getDownloadURL();
            setAvatarImg(imgURL);
        }

        if (avatar) {
            fetchImg(avatar);
        }

    }, [avatar]);

    return (
        <img className="img-60 rounded-circle" src={avatarImg} alt="Avatar" />
    )

}


const TeamMembers = (props) => {
    const searchValue = "";
    const [users, setUsers] = useState([]);
    const db = firebase.firestore();

    useEffect(() => {
        const unsubscribe = db.collection('client_team').onSnapshot((snapshot) => {
            const getUser = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }))
            setUsers(getUser)
        })
        return () => unsubscribe();
    }, [db]);

    const deleteUser = (userId) => {
        deletedUser(userId);
    }

    const handleSearchKeyword = (keyword) => {
        db.collection("client_team").where('nameToSearch', '>=', keyword).where('nameToSearch', '<=', keyword + '\uf8ff')
            .onSnapshot((snapshot) => {
                const getUser = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }))
                setUsers(getUser);
            })
    }

    const redirectUrl = () => {
        props.history.push(`${process.env.PUBLIC_URL}/team/add-user`);
    }

    const editUser = (user) => {
        props.history.push(`${process.env.PUBLIC_URL}/team/edit-user/${user.id}`);
    }

    const handlePriority = (priority, userId, e) => {
        e.stopPropagation();
        markPriority(priority, userId);
    }

    return (
        <Fragment>
            <Breadcrumb title="Team Members" parent="Our Team" />
            <div className="container-fluid product-wrapper">
                <div className="product-grid">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-6">
                                    <form className="search-form contact-search">
                                        <div className="form-group mb-0">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="search"
                                                defaultValue={searchValue}
                                                onChange={(e) => handleSearchKeyword(e.target.value)}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="col-xl-6">
                                    <div className="contact-filter pull-right">
                                        <button className="btn btn-primary ml-4" onClick={redirectUrl}>
                                            ADD
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="product-wrapper-grid">
                        <div className="row">
                            {users.length > 0 ?
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="product-box table-responsive contact-table">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <h5 className="mb-0">Priority</h5>
                                                        </th>
                                                        <th>
                                                            <h5 className="mb-0">Profile</h5>
                                                        </th>
                                                        <th>
                                                            <h5 className="mb-0">Name</h5>
                                                        </th>
                                                        <th>
                                                            <h5 className="mb-0">Title</h5>
                                                        </th>
                                                        <th >
                                                            <h5 className="mb-0">Mobile</h5>
                                                        </th>
                                                        <th >
                                                            <h5 className="mb-0">Social Media</h5>
                                                        </th>
                                                        <th colSpan="2">
                                                            <h5 className="mb-0">Actions</h5>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {users.map((user, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <a href="#" onClick={e => handlePriority(!user.priority, user.id, e)} >
                                                                        {
                                                                            user.priority ?
                                                                                <i className="fa fa-star"></i>
                                                                                :
                                                                                <i className="fa fa-star-o"></i>
                                                                        }
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <AvatarImage avatar={user.avatar} />
                                                                </td>
                                                                <td>
                                                                    <h6>{user.name}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{user.title}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{user.mobile}</h6>
                                                                </td>
                                                                <td>
                                                                    {user.social_media.map(social => {
                                                                        switch (social.name) {
                                                                            case 'Email': return <Mail key="social_email" alt={social.value} />
                                                                            case 'Instagram': return <Instagram key="social_ig" alt={social.value} />
                                                                            case 'Facebook': return <Facebook key="social_facebook" alt={social.value} />
                                                                            case 'Linkedin': return <Linkedin key="social_linked" alt={social.value} />
                                                                            case 'Twitter': return <Twitter key="social_twitter" alt={social.value} />
                                                                            default:
                                                                        }
                                                                    })}
                                                                </td>
                                                                <td><button className="btn btn-primary mr-2" onClick={() => editUser(user)} >Edit</button>
                                                                    <button className="btn btn-secondary" onClick={() => deleteUser(user.id)}>Delete</button></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                                :
                                <div className="col-sm-12">
                                    <div>
                                        <div className="search-not-found text-center">
                                            <div>
                                                <img src={search} alt="" className="second-search" />
                                                <p className="mb-0">Sorry, We didn't find any results matching this search</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default TeamMembers;